<template>
    <div class="col-12" id="simpleLetterComponent">
        <div class="row">
            <div class="col-12">
                <table style="width:750px; padding-top:0px;  border: 0px dashed orange;">
                    <tr>
                        <td>
                            <table>
                                <tr>
                                    <td valign="top" style="width:60%; max-width: 200px; padding: 3px 15px; padding-right: 10px; border: 0px dashed blue;">
                                        <div style="width:150px; height:90px; position: relative; text-align: center; border: 0px solid #000; margin:0px auto;">
                                            <img style="border: 0px solid red;" :src="logo" alt="logo" width="150" height="auto" v-if="Showlogo">
                                        </div>
                                    </td>
                                    <td style="line-height: 1.3; font-size:12px; color:#555;">
                                        {{getorginfo.bill_company_name}} <br />
                                        {{getorginfo.bill_address}} <br />
                                        {{getorginfo.bill_city}}, {{getorginfo.bill_state}} {{getorginfo.bill_zip_code}} <br />
                                        {{getorginfo.bill_telephone}} <br />
                                        {{getorginfo.bill_email}} <br />
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td valign="top" style="width:35%;border: 0px dashed blue;">
                            <!-- <h4 style="color:#555;margin:0; padding:0;text-align:right;display: block; font-size:25px;margin-bottom:2px;font-weight: normal;"> Estimate #{{ numDoc }}</h4>
                            <span style="text-align:right;display: block;font-size:14px;">
                            Date: {{ showDateCreated || '' }}<br />
                            </span> -->
                        </td>
                    </tr>
                </table>
                <div class="row">
                    <div class="col-lg-6" style="">
                        <!-- <input type="text" class="form-control" v-model="content.title" placeholder="Title Letter" /> -->
                    </div>
                    <div class="col-lg-6" style="">
                        <!-- <div class="row form-inline">
                            <div class="my-1 mr-2" style="margin-right: 5px;margin-left: 15px;">
                                <label for="contractLetter">
                                    Include this document?
                                </label>
                            </div>
                            <div class="custom-control custom-checkbox my-1 mr-sm-2">
                                <input type="checkbox" class="custom-control-input" id="contractLetter" v-model="form.letter" @change="setUpdate"/>
                                <label class="custom-control-label" for="contractLetter">Yes</label>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="col-12" style="margin-top: 0px;">
                <div class="bgAgua" :style="Showlogo > 0 ? {'background-image': bgAgua} : {}"></div>
                <vue-editor class="simpleLetter" v-model="content.description" @text-change="setUpdate" :editor-toolbar="customToolbar"
                :customModules="customModulesForEditor" :editorOptions="editorSettings" useCustomImageHandler :placeholder="placeholcelderText"
                @image-added="handleImageAdded" @image-removed="handleImageDeleted"/>
            </div>
            <div class="col-1"></div>
            <div class="col-5">
                <div class="form-group row text-left">
                    <div class="col-sm-10">
                        <div id="previewSignLetter" class="fontStyle5" v-if="signature!=null">{{signature}}</div>
                        <input type="text" class="form-control" v-model="FormSignature.nameCompany" @change="setUpdate"
                        style="text-align: center; border:0; border-radius: 0; background: transparent; font-weight:bold; color:#000; padding-bottom: 0; font-size: 16px;"/>
                    </div>
                </div>
            </div>
            <div class="col-1"></div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import './simpleLetter.scss';
import { VueEditor, Quill } from 'vue2-editor';
// import { ImageDrop } from 'quill-image-drop-module';
import ImageResize from "quill-image-resize-module";
export default {
    components: {
        VueEditor,
    },
    name: 'simpleLetter',
    props: {
        propForm: {
            type: Object,
            required: true
        },
        propTemplateLetter: {
            type: Object,
            required: true
        },
        propFormSignature: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            content: this.propTemplateLetter,
            customToolbar: [
                [
                    { header: [1, 2, 3, 4, 5, 6, false] },
                    "bold", "italic", "underline", "strike",
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" },
                    { list: "ordered" },
                    { list: "bullet" },
                    { color: [] },
                    "link",
                    "image",
                    "clean"
                ]
            ],
            customModulesForEditor: [
                // { alias: "imageDrop", module: ImageDrop },
                { alias: "imageResize", module: ImageResize }
            ],
            editorSettings: {
                modules: {
                    // imageDrop: true,
                    imageResize: ImageResize,
                }
            },
            form: this.propForm,
            Showlogo: false,
            logo: '',
            bgAgua: '',
            placeholcelderText: 'Write the content of the letter here...',
            FormSignature: this.propFormSignature,
            fontStyle: 5,
            showSign: 0,
            signature: '',
        };
    },
    created(){
        this.getLogo();
        this.getSignature();
        this.signature = this.propFormSignature.nameCompany;
    },
    mounted(){
        let t = this;
        // Selecciona el elemento que quieres observar
        const target = document.querySelector('#simpleLetterComponent .simpleLetter.quillWrapper .ql-editor');
        const headerToolBarEditor = document.querySelector('#simpleLetterComponent .simpleLetter.quillWrapper .ql-snow.ql-toolbar');
        // Crea el observador
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                console.log('✅ La sección está visible en pantalla');
                // Aquí puedes disparar tu evento o acción:
                    headerToolBarEditor.classList.add('toFix');
                } else {
                    console.log('⛔ La sección salió de la vista');
                    headerToolBarEditor.classList.remove('toFix');
                }
            });
        }, {
            root: null, // viewport
            threshold: 0.3 // porcentaje visible (0.3 = 30%)
        });
        // Empieza a observar
        observer.observe(target);
    },
    methods: {
        setUpdate() {
            this.$emit('updateLetter',{
                'letter': this.form.letter,
                'description': this.content.description,
                'title': this.content.title,
            });
        },
        handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
            let t = this;
            var setImage = new FormData();
            setImage.append("user_id", window.master_client);
            setImage.append("org_id", window.localorgdata);
            setImage.append("folder", 'so_task');
            setImage.append("img1", file, file.name);
            setImage.append("nombreIMG", "img");
            setImage.append("task_id", new Date().getTime().toString());
            setImage.append("contIMG", 1);
            setImage.append("delIMG", "imgOld");
            setImage.append("contDel", 0);
            window.masterGetBilling
            .post("subirIMG", setImage)
            .then(result => {
                let url = window.urlmaster+'images/no-image.png'; // imagen x defaul
                let name_image = '';
                if(result.data.imgs["1"]){
                    url = window.urlmaster + result.data.rooPath.slice(1) + result.data.imgs["1"];
                    name_image = result.data.imgs["1"];
                    Editor.insertEmbed(cursorLocation, "image", url);
                    // Espera un momento para que Quill inserte el DOM y luego accede a la imagen
                    setTimeout(() => {
                        const editorEl = document.querySelector('.ql-editor');
                        const imgs = editorEl.querySelectorAll('img');
                        const lastImg = imgs[imgs.length - 1];
                        if (lastImg && lastImg.src === url) {
                        lastImg.classList.add('img-editor-custom');
                        lastImg.setAttribute('width', '200px'); // ⬅ ancho inicial
                        lastImg.setAttribute('height', 'auto'); // mantiene proporción
                        }
                    }, 10);
                    resetUploader();
                }else{
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: "Error:",
                        text: "Image upload failed, please try again.",
                    });
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        handleImageDeleted: function (file, Editor, cursorLocation, resetUploader) {
            console.log('handleImageDeleted', file, Editor, cursorLocation, resetUploader)
            let t = this;
            file = file.split('so_task/');
            var setImage = new FormData();
            setImage.append("user_id", window.master_client);
            setImage.append("org_id", window.localorgdata);
            setImage.append("folder", 'so_task');
            setImage.append("image", file[1]);
            window.masterGetBilling
            .post("delOnlyIMG", setImage)
            .then(result => {
                let url = window.urlmaster+'images/no-image.png'; // imagen x defaul
                let name_image = '';
                if(!result.data.status){
                    console.log('delOnlyIMG', result.data)
                }else{
                    t.$notify({
                        group: "noti",
                        type: "error",
                        title: "Error:",
                        text: "Image upload failed, please try again.",
                    });
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getLogo() {
            let t= this;
            window.master
            .get("bg/logo/" + window.localuserdata + "/" + +window.master_client)
            .then((response) => {
                console.log(response.data);
                t.Showlogo = response.data.Showlogo;
                t.logo = response.data.logo;
                t.bgAgua = "url";
                t.bgAgua += "(";
                t.bgAgua += response.data.logo;
                t.bgAgua += ")";
                console.log("bg/logo/", t.bgAgua);
                //t.getBgs();
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getSignature() {
			let t = this;
			window.master.post("getSignature", {
				user_id: window.master_client,
				org_id: window.localorgdata,
			})
			.then((response) => {
				console.log(response.data);
				if(response.data.status){
					let val = JSON.parse(response.data.r.meta_value);
					if(val){
						t.fontStyle = val.fontStyle || 5;
						t.showSign = val.showSign || 0;
                        t.signature = val.signature;
					}
				}
				setTimeout(function(){
					let previewSignLetter = document.querySelector("#previewSignLetter");
                    if(!previewSignLetter) return;
                    if(previewSignLetter.classList.length>0) {
                        previewSignLetter.removeAttribute('class');
                    }
                    previewSignLetter.classList.add('fontStyle'+t.fontStyle);
			}, 1000);
			})
			.catch((error) => {
				console.log(error);
			});
		},
    },
    watch: {
    },
    computed: {
        ...mapGetters("core/Org", {getorginfo: "orginf"}),
        numDoc: function() {
            const num = this.form?.numdoc ?? '';
            return String(num).padStart(4, '0');
        },
        showDateCreated() {
            if(this.form.actionNname == 'create'){
                return new Date().toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" });
            }
            let dateValue = this.form?.date_created;
            if (!dateValue || dateValue.length < 10) {
                return new Date().toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" });
            }
            // console.log('date_created', dateValue)
            let dateSinHoras = (typeof dateValue === 'string' && dateValue.includes('T')) ? dateValue.split('T')[0] : dateValue;
            // let parts = dateSinHoras.split("-");
            // console.log('parts', parts);
            let date = new Date(dateSinHoras); // YYYY-MM-DD
            return date.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" }); // formato corto, Feb 1, 2021
        },
    },
}
</script>
